// extracted by css-extract-rspack-plugin
export default {"cls1":"TopSection-cls1_rud","cls2":"TopSection-cls2_C0t TopSection-cls1_rud"};